import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "course-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.2468 5.51779C5.24699 4.12271 6.2443 2.78308 7.70574 2.78308H16.2934C17.7505 2.78308 18.7609 4.11779 18.7609 5.51819V19.4638C18.7609 20.8845 17.1573 21.7132 15.9984 20.8912L12.1442 18.1574C12.0576 18.0959 11.9416 18.0959 11.8549 18.1574L8.0017 20.8904C6.84251 21.7127 5.23849 20.8833 5.23926 19.4621L5.2468 5.51779C5.2468 5.51792 5.2468 5.51765 5.2468 5.51779ZM7.70574 4.28308C7.27804 4.28308 6.7468 4.72979 6.7468 5.51819L6.73926 19.4629C6.73915 19.6659 6.96829 19.7844 7.13389 19.667L10.9871 16.9339C11.5935 16.5038 12.4056 16.5038 13.012 16.9339L16.8663 19.6677C17.0318 19.7851 17.2609 19.6668 17.2609 19.4638V5.51819C17.2609 4.73498 16.7255 4.28308 16.2934 4.28308H7.70574Z"
    }, null, -1)
  ])))
}
export default { render: render }